import { LogsUsuarioListSearchComponent } from './LogsUsuarioListSearchComponent'

export const LogsUsuarioListHeader = () => {
  return (
    <div className='card-header border-0 pt-6'>
      <LogsUsuarioListSearchComponent />
    </div>
  )
}
